import { render, staticRenderFns } from "./select-box.vue?vue&type=template&id=c4c5426e&scoped=true"
import script from "./select-box.vue?vue&type=script&lang=js"
export * from "./select-box.vue?vue&type=script&lang=js"
import style0 from "./select-box.vue?vue&type=style&index=0&id=c4c5426e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c5426e",
  null
  
)

export default component.exports